import styles from "../index.module.css";
import { store, Checkout, Config } from "@cleeng/mediastore-sdk";
import { Provider } from "react-redux";
import "@adyen/adyen-web/dist/adyen.css";
import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { useTranslateLang } from "~/translateLangContext";


export default function Page() {

  const router = useRouter()
  const { id, couponOffer } = router.query;

  const [item_id, setId] = useState("error");
  const [item_name, setName] = useState("error");
  const [item_category, setCategory] = useState("error");
  const [price, setPrice] = useState(0.00);
  const [currency, setCurrency] = useState("error");
  const [isLoading, setIsLoading] = useState(true);

  const { key4 } = useTranslateLang();
  
  useEffect(() => {
    setIsLoading(true);
    getOfferInfo().finally(() => {
      setIsLoading(false);
    });
  }, []);

  Config.setVisibleAdyenPaymentMethods(["applepay", "googlepay", "card"]);

  const clearOfferFromStore = () => {
    localStorage.CLEENG_OFFER_ID.clear();
    localStorage.CLEENG_OFFER_TYPE.clear();
  }

  const getOfferInfo = async () => {
    await axios.get(`https://${process.env.NEXT_PUBLIC_CAPI_HOST}/v1/apps/${process.env.NEXT_PUBLIC_APP_LOOKUP_KEY}/all_offers?locale=${key4}`).then((res) => {
      const filteredRes = res.data.data.filter((offer: any) => offer.customData?.hidden !== 'true')
      const currentOffer = filteredRes.filter((offer: any) => offer.offerId == id);
      if (currentOffer.length > 0 && typeof currentOffer[0] === 'object' && currentOffer[0] !== null) {
        setId(currentOffer[0].offerId as string);
        setName(currentOffer[0].title as string);
        setCategory(currentOffer[0].offerType as string);
        setPrice(currentOffer[0].price.amount as number);
        setCurrency(currentOffer[0].price.currency as string);
      }

    }).catch((err) => {
      console.log(err);
    });
  };

  const handleCheckoutSuccess = () => {
    window.gtag?.('event', 'purchase', {
      currency: currency,
      items: [
        {
          item_id: item_id,
          item_name: item_name,
          item_category: item_category,
          price: price,
          quantity: 1
        }
      ]
    });
  }

  return <div>
    <Provider store={store}>
      <Checkout offerId={id} className={styles.checkoutClass} couponCode={couponOffer} onSuccess={() => handleCheckoutSuccess()} />
    </Provider>
    <a href={`/`} className={styles.buttonDiv} onClick={() => clearOfferFromStore()}>
      <Trans i18nKey='buttons.back'>
      BACK TO OFFERS
      </Trans>
      </a>
  </div>
}
